import { createStrictContext } from 'utils/createContext'
import {
  GetCasRoutingGroupsQuery,
  GetCasRoutingGroupsQueryHookResult,
  useGetCasRoutingGroupsQuery,
} from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

export type RoutingGroup =
  GetCasRoutingGroupsQuery['casRoutingGroups']['records'][number]

const { Provider, useContextFn } = createStrictContext<
  Pick<GetCasRoutingGroupsQueryHookResult, 'refetch'> & {
    records: RoutingGroup[]
    fetching: GetCasRoutingGroupsQueryHookResult['loading']
  }
>('RoutingGroupsTableContext')

export const useRoutingGroupsTableContext = useContextFn

export const RoutingGroupsTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetCasRoutingGroupsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      casRoutingGroupListInput: { projectId: { equals: projectId } },
    },
  })

  return (
    <Provider
      value={{
        records: data?.casRoutingGroups.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
